import { RouteConfig } from "vue-router";

const LoginRoute: Array<RouteConfig> = [
    {
        path: "/login",
        component: () => import("@/views/ap/login/Login.vue")
    },
    {
        path: "/forget",
        component: () => import("@/views/ap/login/Forget.vue")
    },
    {
        path: "/reset",
        component: () => import("@/views/ap/login/Reset.vue")
    },
];

export { LoginRoute };
